import { authModule } from '@/store'
import { intersectRoles } from '@/../common/shareds/sharedAuth'

export { intersectRoles }

export const hasRole = (role: Parameters<typeof intersectRoles>[0]) => intersectRoles(role, authModule.role)
